import uploadFileWithFormData from './uploadFileWithFormData';

export default function uploadLogoFileWithOptions (
  file: File,
  opts?: {
    container?: string;
    folderPath?: string;
  },
) {
  const formData = new FormData();
  if (opts.folderPath && opts.folderPath.trim().length !== 0) {
    const _folderPath = opts.folderPath.split('/');
    _folderPath.push('logos');
    formData.append('folderPath', `${_folderPath.join('/')}/`);
  } else {
    formData.append('folderPath', 'logos/');
  }
  formData.append('file', file);
  formData.append('containerName', opts.container);
  return uploadFileWithFormData(formData, file.type);
}
